module.exports = __webpack_public_path__ + "static/media/proj20_img11.e46559ae.jpg";